export default {
  'pt-BR': 'Português (BR)',
  'pt-PT': 'Português (PT)',
  'en-US': 'Inglês (US)',
  'es-ES': 'Espanhol (ES)',
  'ja-JP': 'Japonês (JP)',
  options: [
    { value: 'pt-BR', text: 'Português (BR)' },
    { value: 'pt-PT', text: 'Português (PT)' },
    { value: 'en-US', text: 'Inglês (US)' },
    { value: 'es-ES', text: 'Espanhol (ES)' },
    { value: 'ja-JP', text: 'Japonês (JP)' },
  ],
}
